import React, { FC } from 'react';
type MonitoringFormsAccordionTitlePropsType = {
  title: string;
  formId?: string;
  isOpened?: boolean;
  count?: number;
};
const MonitoringFormsAccordionTitle: FC<MonitoringFormsAccordionTitlePropsType> = (props) => {
  const { title, count } = props;

  return (
    <>
      <div className="flex items-center gap-[10px]">
        <div className="font-[700] text-[16px] text-2color leading-[110%] tracking-tight truncate">
          {title || ''}
        </div>
        <div className="flex justify-center items-center text-xs w-[17px] h-[17px] rounded-full ml-[13px] text-[11px] bg-defaultBgBtn !text-white">
          {count}
        </div>
        {/*{isOpened && (*/}
        {/*  <CircleButton*/}
        {/*    size={14}*/}
        {/*    onClick={onDelete}*/}
        {/*    className={'text-dangerBg'}*/}
        {/*    // className={`${presetsCount === 0 ? 'text-dangerBg' : 'text-3color'}`}*/}
        {/*    icon={'TrashIcon'}*/}
        {/*    stopPropagation*/}
        {/*  />*/}
        {/*)}*/}
      </div>
    </>
  );
};

export default MonitoringFormsAccordionTitle;
